import { jsx } from 'panel';
import isEmpty from 'lodash/isEmpty';
import { DisplayPlotStyle } from 'common/charts/visualization/line-chart/enums';
import { LineChartEl } from 'common/charts/visualization/line-chart';
import { SpinnerEl } from 'common/components/spinner';
import { SegmentLegendHeaderEl } from 'common/charts/misc/segment-legend-header';
import { abbreviateNumber3SigFigs } from 'common/util';
import { renderLineChartTooltip } from 'common/report/util/insights/tooltip';
import { ContextMenuEl } from 'common/widgets/context-menu';
import { EmptyData } from 'common/charts/misc/mixins/empty-data';
export function template() {
  var _a;

  const loaded = this.attr("loaded") && this.hasRequiredParams() && this.state.lineChartData;

  if (!loaded) {
    return jsx("div", {
      sel: '.root'
    }, jsx(SpinnerEl, {
      attrs: {
        elref: "loadingSpinner"
      }
    }));
  }

  if (isEmpty((_a = this.results) === null || _a === void 0 ? void 0 : _a.series)) {
    return jsx("div", {
      sel: '.root'
    }, jsx(EmptyData, null));
  }

  const {
    lineChartData
  } = this.state;
  const visibleChartSeries = lineChartData.lineChartSeries.filter(chartSegment => {
    return this.segmentFilterController.isItemSelected(0, chartSegment.name);
  }); // reverse the sorted order of segments in Standard plot style because <mp-line-chart> determines that the segments defined last are visually on top

  if (lineChartData.chartPlotStyle === DisplayPlotStyle.Standard) {
    visibleChartSeries.reverse();
  } // TODO: failure state


  return jsx("div", {
    sel: '.root'
  }, jsx(SegmentLegendHeaderEl, null), jsx(LineChartEl, {
    sel: '.line-chart',
    attrs: {
      elref: "lineChart",
      'time-unit': lineChartData.chartTimeUnit,
      'display-analysis-type': lineChartData.chartAnalysisType,
      'display-plot-style': lineChartData.chartPlotStyle,
      'display-stacking-type': lineChartData.chartStackingType,
      'show-annotations': this.attr("show-annotations"),
      'utc-offset': this.getProjectTimezone().utcOffset,
      timezone: this.getProjectTimezone().timezone,
      'y-axis-options': {
        softMin: 0
      },
      'zoom-type': "x"
    },
    props: {
      selectedSeriesPoint: this.state.popoverSelectionIndex,
      chartData: visibleChartSeries,
      formatTooltip: (_x, _y, _series, _seriesIdx, tooltipContext) => renderLineChartTooltip(this.generatePointTooltipParams(tooltipContext)),
      formatYAxisLabel: y => abbreviateNumber3SigFigs(y),
      onHighChartClick: (chartSeries, dataIdx, _color, plotX, plotY) => this.handlePointClick(chartSeries, dataIdx, plotX, plotY)
    }
  }), this.state.popoverSelection && jsx(null, null, jsx(ContextMenuEl, {
    attrs: {
      'menu-items': this.getPopoverAttrs()["button-options"],
      'relative-positioning': true,
      open: true,
      position: {
        left: 0,
        top: 0
      }
    },
    style: this.state.popoverStyles,
    on: {
      action: ev => this.handlePopoverAction(ev),
      close: () => this.handlePopoverClose()
    }
  })));
}